export default [
  {
    text: 'venue.table.name',
    value: 'name',
    default: true,
  },
  {
    text: 'venue.table.shortId',
    value: 'readableId',
    default: true,
  },
  {
    text: 'venue.table.email',
    value: 'email',
    default: true,
  },
  {
    text: 'venue.table.street',
    value: 'street',
    default: true,
  },
  {
    text: 'venue.table.number',
    value: 'number',
    default: true,
  },
  {
    text: 'venue.table.legalForm',
    value: 'legalForm',
    default: false,
  },
  {
    text: 'venue.table.locType',
    value: 'locType',
    default: false,
  },
  {
    text: 'venue.table.city',
    value: 'city',
    default: true,
  },
];
